<script lang="ts">
import { defineComponent, PropType, inject } from 'vue'
import NewsletterSetup from '@/components/newsletter/NewsletterSetup.vue'

export default defineComponent({
  name: 'NewsletterSetupForRegistration',

  components: {
    NewsletterSetup,
  },

  props: {
    namespace: {
      type: String,
      default: '',
    },

    inputOptionalNewsletterInfo: {
      type: Object as PropType<OptionalNewsletterSettings>,
      required: true,
    },
  },

  emits: [
    'update:mailStopFlag',
    'update:mailNewsStopFlag',
    'update:mailExpoStopFlag',
    'update:mailAiStopFlag',
  ],

  setup() {
    const MAIL_STOP_CATEGORIES = inject<Record<string, { title: string, desc: string }>>('MAIL_STOP_CATEGORIES')!

    return {
      // constants
      MAIL_STOP_CATEGORIES,
    }
  },
})
</script>

<template>
  <NewsletterSetup
    :namespace="namespace"
    :input-optional-newsletter-info="inputOptionalNewsletterInfo"
    :has-border="false"
    @update:mail-stop-flag="$emit('update:mailStopFlag', $event)"
    @update:mail-news-stop-flag="$emit('update:mailNewsStopFlag', $event)"
    @update:mail-expo-stop-flag="$emit('update:mailExpoStopFlag', $event)"
    @update:mail-ai-stop-flag="$emit('update:mailAiStopFlag', $event)" />

  <div class="l-unit__defaultNewsletter">
    <div class="l-unit__defaultNewsletter--header">
      <div class="o-note">
        <p class="o-note--item u-text__x-small">
          受け取りたいニュースレターを選んでください。広告を含むニュースレターは登録後に配信停止できます。
        </p>
      <!-- /.o-note --></div>
    <!-- /.l-unit__defaultNewsletter header --></div>

    <div class="l-unit__defaultNewsletter--description">
      <dl class="dl">
        <dt class="dt u-text__bold u-text__small">
          {{ MAIL_STOP_CATEGORIES.mail_pr2_stop_flg.title }}
        </dt>
        <dd class="dd u-text__small">
          {{ MAIL_STOP_CATEGORIES.mail_pr2_stop_flg.desc }}
        </dd>
      </dl>

      <dl class="dl">
        <dt class="dt u-text__bold u-text__small">
          {{ MAIL_STOP_CATEGORIES.mail_pr1_stop_flg.title }}
        </dt>
        <dd class="dd u-text__small">
          {{ MAIL_STOP_CATEGORIES.mail_pr1_stop_flg.desc }}
        </dd>
      </dl>

      <dl class="dl">
        <dt class="dt u-text__bold u-text__small">
          {{ MAIL_STOP_CATEGORIES.mail_pr3_stop_flg.title }}
        </dt>
        <dd class="dd u-text__small">
          {{ MAIL_STOP_CATEGORIES.mail_pr3_stop_flg.desc }}
        </dd>
      </dl>
    <!-- /.l-unit__defaultNewsletter description --></div>
  <!-- /.l-unit__defaultNewsletter --></div>
</template>

<style lang="sass" scoped>
.l-unit__defaultNewsletter
  $root: &
  display: flex
  flex-direction: column
  margin-top: 2em

  &:first-child
    margin-top: 0

  & &--header
    margin-bottom: 0.25em

  & &--description
    padding: 1em
    background-color: rgba($bg-x-light-gray, 1)
</style>
